// client/src/pages/common/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const NotFound = () => {
  const { t } = useTranslation(['business', 'common']);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow flex items-center justify-center text-center px-4 pt-16 lg:pt-0">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md">
          <h1 className="text-6xl font-bold text-gray-800 mb-4">
            {t('business:notFound.title')}
          </h1>
          
          <h2 className="text-2xl font-semibold text-gray-700 mb-2">
            {t('business:notFound.subtitle')}
          </h2>
          
          <p className="text-lg text-gray-600 mb-6">
            {t('business:notFound.message')}
          </p>
          
          <Link
            to="/"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-700 transition-colors"
          >
            {t('business:notFound.goHome')}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;